import React from 'react';
import EstudiantesTable from './TableEstudiantes/TableEstudiantes';

const Estudiantes = () => {
  return <EstudiantesTable/> ;
};

export default Estudiantes;
